export const API_SCHEMA = "https://";
export const API_DOMAIN = "api.meezban.net";
export const APP_URL = "https://app.meezban.net";